import type { CalendarPostType } from "features/calendar-new/types";

export interface ApprovalBoardPostsData {
  posts: CalendarPostType[];
  postById: Record<string, CalendarPostType>;
}

export function indexApprovalBoardPosts(
  posts: CalendarPostType[]
): ApprovalBoardPostsData {
  return {
    posts,
    postById: Object.fromEntries(posts.map((post) => [post._id, post])),
  };
}

export function getApprovalBoardStatusFilterFromQueryKey(
  queryKey: readonly unknown[]
) {
  const postStatusKeys = queryKey[4];
  return Array.isArray(postStatusKeys) ? (postStatusKeys as string[]) : [];
}
